import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from '../services/shared-data.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  standalone: false
})
export class MessageComponent {
  state: { message: string };

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.state = navigation?.extras?.state as { message: string };
    if (this.sharedDataService.getCurrentUser() === null) {
      // If the user is null, we mark user as loaded to display the default logo
      this.sharedDataService.markUserLoaded();
    }
  }
}
